const fontSizes = {
    xxxs: "xxxs",
    xxs: "xxs",
    xs: "xs",
    sm: "sm",
    base: "base",
    lg: "lg",
    xl: "xl",
    xxl: "xxl",
    xxxl: "xxxl",
};
export default Object.freeze(fontSizes);
